﻿let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  TextInput,
  FlatList,
  ActivityIndicator,
  Alert,
  Modal,
  Dimensions,
  Animated,
  RefreshControl,
  Image,
  Linking, // Added Linking for external apply
} from 'react-native';
import { apiFetch } from '../../utils/apiClient';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient'; // Ensure expo-linear-gradient is installed
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useProfessional } from '../../context/ProfessionalContext';
import { useProfessionalOnboarding } from '../../context/ProfessionalOnboardingContext';
import { useGeneral } from '../../context/GeneralContext';

// ⬇️ Import Unified API Functions
import { 


  searchJobsByType, // We will use this to get "fulltime" jobs
  getAPIStatus, 
  getConfiguredAPIs,
  getJobTypeStatistics 
} from '../../services/unifiedJobAPI';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const { width, height } = Dimensions.get('window');

// ✅ KEPT MOCK DATA as "LOCAL_MOCK_JOBS"
const LOCAL_MOCK_JOBS = [
    {
      id: 'ft_001',
      jobId: 'ft_001',
      title: 'Senior Software Engineer',
      company: 'TechCorp Solutions',
      companyLogo: 'https://logo.clearbit.com/techcorp.com',
      location: 'London, UK',
      salary: '£70,000 - £90,000',
      salaryRange: { min: 70000, max: 90000 },
      type: 'Full-time',
      remote: false,
      isRemote: false,
      posted: '2 days ago',
      description: 'Lead development of cutting-edge software solutions in a dynamic team environment. Excellent career progression opportunities.',
      requirements: ['React', 'Node.js', 'TypeScript', 'AWS', '5+ years experience', 'Team Leadership'],
      benefits: ['Health Insurance', 'Pension Scheme', '25 Days Holiday', 'Flexible Working', 'Learning Budget', 'Stock Options'],
      matchScore: 94,
      featured: true,
      urgent: false,
      experienceLevel: 'Senior',
      industry: 'Software Engineering', // Specific industry
      companyInfo: {
        size: '500-1000 employees',
        industry: 'Software Development',
        founded: '2015',
        rating: 4.7,
        culture: 'Innovation-focused',
      },
      careerProgression: {
        nextRole: 'Lead Engineer',
        timeframe: '18-24 months',
        growthOpportunities: ['Technical Leadership', 'Architecture Design', 'Team Management'],
      },
      dataSource: 'Local', // Identify as local
    },
    {
      id: 'ft_002',
      jobId: 'ft_002',
      title: 'Graduate Civil Engineer',
      company: 'BuildRight UK',
      companyLogo: 'https://logo.clearbit.com/buildright.com',
      location: 'Manchester, UK',
      salary: '£28,000 - £35,000',
      salaryRange: { min: 28000, max: 35000 },
      type: 'Full-time',
      remote: false,
      isRemote: false,
      posted: '1 day ago',
      description: 'Join our graduate program for Civil Engineers. Work on major infrastructure projects.',
      requirements: ['Civil Engineering Degree', 'CAD Software', 'Team Player'],
      benefits: ['Health Insurance', 'Performance Bonus', 'Professional Development (ICE)'],
      matchScore: 88,
      featured: false,
      urgent: true,
      experienceLevel: 'Entry Level',
      industry: 'Civil Engineering', // Specific industry
      companyInfo: {
        size: '1000+ employees',
        industry: 'Construction',
        founded: '1990',
        rating: 4.5,
        culture: 'Data-driven',
      },
      careerProgression: {
        nextRole: 'Project Engineer',
        timeframe: '24-36 months',
        growthOpportunities: ['Chartership', 'Project Management'],
      },
      dataSource: 'Local', // Identify as local
    },
];


/**
 * Helper: Transforms a job from the unifiedJobAPI into the structure
 * expected by the FullTimeJobCard component.
 */
const transformApiJob = (job) => {
  const titleLower = job.title?.toLowerCase() || '';
  
  // Experience Level
  let experienceLevel = 'Mid-Level';
  if (titleLower.includes('senior')) experienceLevel = 'Senior';
  else if (titleLower.includes('lead') || titleLower.includes('principal')) experienceLevel = 'Lead';
  else if (titleLower.includes('junior') || titleLower.includes('grad')) experienceLevel = 'Entry Level';

  // ✅ UPDATED: Discipline detection
  let industry = 'General Engineering';
  if (titleLower.includes('civil')) industry = 'Civil';
  else if (titleLower.includes('mechanical')) industry = 'Mechanical';
  else if (titleLower.includes('electrical') || titleLower.includes('electronic')) industry = 'Electrical';
  else if (titleLower.includes('architect')) industry = 'Architecture';
  else if (titleLower.includes('software') || titleLower.includes('developer')) industry = 'Software';
  else if (titleLower.includes('data')) industry = 'Data Science';
  else if (titleLower.includes('design')) industry = 'Design';
  else if (titleLower.includes('marketing')) industry = 'Marketing';


  return {
    // Data from API
    id: job.id || job.jobId,
    jobId: job.jobId || job.id,
    title: job.title,
    company: job.companyName || job.company || 'Company',
    companyLogo: job.logo || job.clientLogo || `https://logo.clearbit.com/${(job.companyName || 'company').toLowerCase().replace(/\s/g, '')}.com`,
    location: job.location,
    salary: job.salary?.budget || 'Competitive',
    salaryRange: { 
      min: job.salary?.budgetRange?.min || 0, 
      max: job.salary?.budgetRange?.max || 0 
    },
    type: 'Full-time',
    remote: job.isRemote,
    isRemote: job.isRemote,
    posted: job.posted || 'Recently',
    description: job.description,
    requirements: job.requirements || [],
    skills: job.skills || [],
    matchScore: job.matchScore || 75,
    featured: job.featured,
    urgent: job.urgent,
    dataSource: job.dataSource,
    applyLink: job.applyLink,

    // --- Fields required by the UI (defaulted or faked) ---
    experienceLevel: experienceLevel,
    industry: industry, // Use determined discipline
    companyInfo: {
      size: 'N/A',
      industry: industry,
      founded: 'N/A',
      rating: 4.5,
      culture: 'N/A',
    },
    careerProgression: null, // API jobs won't have this
  };
};


// --- Component Start ---
export default function FullTimeJobsScreen({ navigation }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_fulltimejobsscreen`;
    apiFetch('/api/data/jobs?job_type=full-time&is_active=true&sort=created_at&order=desc&limit=50').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // Context hooks
  const { 
    userData = {}, 
    savedJobs = [], 
    jobApplications = [], 
    saveJob, 
    unsaveJob, 
    applyToJob,
    trackUserAction 
  } = useProfessional() || {};
  
  const { 
    profileData = {}, 
    scoring = {}, 
    aiMatching = {},
    runAIProfileAnalysis,
    calculateJobMatch
  } = useProfessionalOnboarding() || {};
  
  const { showToast, trackUserAction: trackGeneralAction } = useGeneral() || {};

  // State management
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTab, setSelectedTab] = useState('all');
  const [isLoading, setIsLoading] = useState(true); // Start loading immediately
  const [refreshing, setRefreshing] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [applyingJobId, setApplyingJobId] = useState(null);
  
  // ✅ UPDATED: Added 'discipline' to filters
  const [selectedFilters, setSelectedFilters] = useState({
    experienceLevel: 'all',
    salaryRange: 'all',
    jobArea: 'all', // Renamed from 'industry'
    discipline: 'all', // New filter
    remote: false,
    benefits: 'all',
  });

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(50)).current;

  // Full-time job tabs
  const fullTimeTabs = [
    { id: 'all', title: 'All Full-Time', icon: 'briefcase-outline' },
    { id: 'recommended', title: 'For You', icon: 'star-outline' },
    { id: 'senior', title: 'Senior', icon: 'trending-up-outline' },
    { id: 'saved', title: 'Saved', icon: 'bookmark-outline' },
    { id: 'applied', title: 'Applied', icon: 'checkmark-circle-outline' },
  ];

  // ⬇️ Data states
  const [allFullTimeJobs, setAllFullTimeJobs] = useState([]); // Will hold combined list
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [apiError, setApiError] = useState(null);
  const [apiSources, setApiSources] = useState({});
  const [localJobCount, setLocalJobCount] = useState(0); // Count for local jobs
  const [apiJobCount, setApiJobCount] = useState(0); // Count for API jobs

  
  /**
   * Fetches data from the Unified API
   */
  const loadJobsFromAPI = async () => {
    try {
      console.log('🔍 Fetching Full-Time Engineering Jobs...');
      
      const configuredAPIs = getConfiguredAPIs();
      if (configuredAPIs.total === 0) {
        setApiError('No job search APIs are configured.');
        return { jobs: [], sources: {} };
      }

      // Use profile job title or default to the broad engineering query
      const userJobTitle = profileData?.personal?.jobTitle;
      let baseQuery;
      
      if (userJobTitle && userJobTitle.trim() !== '') {
        baseQuery = userJobTitle;
      } else {
        // The new, strong query for all engineering types
        const base = '"engineering"';
        const disciplines = '"civil" OR "mechanical" OR "electrical" OR "chemical" OR "aerospace" OR "architectural" OR "structural"';
        baseQuery = `(${base}) AND (${disciplines})`;
      }
      
      // Call searchJobsByType to get only full-time
      const result = await searchJobsByType('fulltime', {
        query: baseQuery,
        location: profileData?.personal?.location || 'United Kingdom',
        remote: selectedFilters.remote,
        page: 1, 
      });

      if (result.success) {
        console.log(`✅ Loaded ${result.total} full-time jobs from API`);
        Object.entries(result.sources).forEach(([source, data]) => {
          if (data.enabled) {
            const status = data.error ? `❌ Error: ${data.error}` : `✅ ${data.count} jobs`;
            console.log(`   ${source}: ${status}`);
          }
        });
        
        return {
          jobs: result.jobs.map(transformApiJob), // Transform data here
          sources: result.sources,
        };
      } else {
        throw new Error(result.error || 'Failed to fetch full-time jobs from APIs');
      }
    } catch (error) {
      console.error('Error loading from APIs:', error);
      setApiError(error.message);
      return { jobs: [], sources: {} };
    }
  };


  /**
   * ✅ UPDATED: Function to orchestrate job loading (API + Local)
   */
  const loadJobs = async () => {
    if (!refreshing) setIsLoading(true);
    setApiError(null);
    
    try {
      // 1. Load Local Jobs (the mock data)
      const storageJobs = LOCAL_MOCK_JOBS.map(job => ({ ...job, dataSource: 'Local' }));
      setLocalJobCount(storageJobs.length);

      // 2. Load API Jobs
      const apiResult = await loadJobsFromAPI();
      setApiJobCount(apiResult.jobs.length);
      
      // 3. Combine Lists
      const combinedJobs = [...storageJobs, ...apiResult.jobs];
      
      setAllFullTimeJobs(combinedJobs);
      setApiSources(apiResult.sources);
      
      // 4. Re-run filtering based on the new data
      filterJobs(searchQuery, selectedTab, combinedJobs); 
      
    } catch (e) {
      // Error is already handled/set by loadJobsFromAPI
    } finally {
      setIsLoading(false);
      setRefreshing(false);
      // Ensure fade-in animation runs on final data load
      animateEntrance();
    }
  };
  
  
  // Load jobs on mount
  useEffect(() => {
    loadJobs();
  }, []); // Run only once on mount

  // Re-filter when filters change
  useEffect(() => {
    filterJobs(searchQuery, selectedTab, allFullTimeJobs);
  }, [selectedFilters]);


  /**
   * ✅ UPDATED: Enhanced job filtering
   */
  const filterJobs = (query = '', tab = 'all', jobsList = allFullTimeJobs) => {
    let filtered = [...jobsList];

    // Filter by search query
    if (query.trim()) {
      const searchLower = query.toLowerCase();
      filtered = filtered.filter(job =>
        (job.title?.toLowerCase() || '').includes(searchLower) ||
        (job.company?.toLowerCase() || '').includes(searchLower) ||
        (job.location?.toLowerCase() || '').includes(searchLower) ||
        (job.description?.toLowerCase() || '').includes(searchLower) ||
        (job.industry?.toLowerCase() || '').includes(searchLower) || // Checks discipline
        (job.experienceLevel?.toLowerCase() || '').includes(searchLower) ||
        (job.requirements && job.requirements.some(req => 
          (req?.toLowerCase() || '').includes(searchLower)
        ))
      );
    }

    // Filter by tab
    switch (tab) {
      case 'recommended':
        filtered = filtered.filter(job => job.matchScore >= 85);
        break;
      case 'senior':
        filtered = filtered.filter(job => (job.experienceLevel || '').includes('Senior'));
        break;
      case 'saved':
        filtered = filtered.filter(job => isJobSaved(job.id));
        break;
      case 'applied':
        filtered = filtered.filter(job => isJobApplied(job.id));
        break;
    }

    // --- Apply additional modal filters ---
    
    // Experience
    if (selectedFilters.experienceLevel !== 'all') {
      filtered = filtered.filter(job => 
        (job.experienceLevel || '').toLowerCase().includes(String(selectedFilters.experienceLevel ?? '').toLowerCase())
      );
    }
    
    // Salary
    if (selectedFilters.salaryRange !== 'all') {
      filtered = filtered.filter(job => {
        const minSalary = job.salaryRange?.min || 0;
        switch (selectedFilters.salaryRange) {
          case '40-60k':
            return minSalary >= 40000 && minSalary <= 60000;
          case '60-80k':
            return minSalary >= 60000 && minSalary <= 80000;
          case '80k+':
            return minSalary >= 80000;
          default:
            return true;
        }
      });
    }

    // Job Area
    if (selectedFilters.jobArea !== 'all') {
      filtered = filtered.filter(job => 
        (job.industry || '').toLowerCase().includes(String(selectedFilters.jobArea ?? '').toLowerCase())
      );
    }

    // ✅ NEW: Discipline Filter
    if (selectedFilters.discipline !== 'all') {
      filtered = filtered.filter(job => 
        (job.industry || '').toLowerCase().includes(String(selectedFilters.discipline ?? '').toLowerCase())
      );
    }

    // Remote
    if (selectedFilters.remote) {
      filtered = filtered.filter(job => job.remote || job.isRemote);
    }

    setFilteredJobs(filtered);
  };

  // Enhanced search handler
  const handleSearch = (query) => {
    setSearchQuery(query);
    filterJobs(query, selectedTab);
  };

  // Tab press handler
  const handleTabPress = (tab) => {
    setSelectedTab(tab.id);
    filterJobs(searchQuery, tab.id);
    
    if (trackUserAction) {
      trackUserAction('fulltime_jobs_tab_change', { tab: tab.id });
    }
  };

  // Refresh handler
  const onRefresh = async () => {
    setRefreshing(true);
    await loadJobs();
  };
  
  // (All other functions: handleSaveJob, isJobSaved, isJobApplied, formatSalary, etc. remain)
  
  // --- Start of remaining required functions/components ---
  
  // Animate entrance
  const animateEntrance = () => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 800,
        useNativeDriver: true,
      }),
      Animated.timing(slideAnim, {
        toValue: 0,
        duration: 800,
        useNativeDriver: true,
      }),
    ]).start();
  };
  
  // Enhanced save job functionality
  const handleSaveJob = async (job) => {
    try {
      const isSaved = isJobSaved(job.id);
      
      if (isSaved) {
        if (unsaveJob && typeof unsaveJob === 'function') {
          await unsaveJob(job.id);
          if (showToast) {
            showToast('Full-time job removed from saved jobs', 'info');
          }
        }
      } else {
        if (saveJob && typeof saveJob === 'function') {
          await saveJob(job);
          if (showToast) {
            showToast('Full-time job saved successfully!', 'success');
          }
        }
      }
      
      if (trackUserAction) {
        trackUserAction('fulltime_jobs_save_toggle', { 
          jobId: job.id, 
          action: isSaved ? 'unsave' : 'save' 
        });
      }
    } catch (error) {
      console.error('❌ FULL-TIME JOBS - Error saving job:', error);
      if (showToast) {
        showToast('Failed to save full-time job', 'error');
      }
    }
  };
  
  // Check if job is saved
  const isJobSaved = (jobId) => {
    return Array.isArray(savedJobs) && savedJobs.some(savedJob => savedJob.id === jobId);
  };
  
  // Check if job is applied
  const isJobApplied = (jobId) => {
    return Array.isArray(jobApplications) && jobApplications.some(app => app.jobId === jobId);
  };
  
  // Format salary for display
  const formatSalary = (salary) => {
    if (typeof salary === 'string') return salary;
    if (salary?.min && salary?.max && salary.min > 0) {
      return `£${(salary.min / 1000).toFixed(0)}k - £${(salary.max / 1000).toFixed(0)}k`;
    }
    return 'Competitive';
  };
  
  // Handle Apply Job
  const handleJobApply = async (job) => {
    // Check if job has apply link (common for API jobs)
    const applyLink = job.applyLink || job.apply_options?.[0]?.link;

    if (applyLink) {
      Alert.alert(
        'Apply to Job',
        'This will open the job application page in your browser.',
        [
          { text: 'Cancel', style: 'cancel' },
          {
            text: 'Continue',
            onPress: async () => {
              try {
                await Linking.openURL(applyLink);
                // Use the correct applyToJob function from context
                await applyToJob(job.id || job.jobId, {
                  appliedAt: new Date().toISOString(),
                  method: 'external',
                });
                showToast?.('Application tracked', 'success');
              } catch (error) {
                console.error('Error opening apply link:', error);
                showToast?.('Could not open application link', 'error');
              }
            },
          },
        ]
      );
    } else {
      // Fallback to internal navigation (for Local jobs)
      try {
        if (!job || !job.id) {
          console.error('❌ FULL-TIME JOBS - No job data provided for application');
          return;
        }
        setApplyingJobId(job.id);
        const navigationParams = {
          jobId: job.id || job.jobId,
          id: job.id || job.jobId,
          job: job,
          jobData: job,
          source: 'FullTimeJobsScreen',
          timestamp: new Date().toISOString(),
          jobType: 'Full-time',
          experienceLevel: job.experienceLevel,
          industry: job.industry,
          salaryRange: job.salaryRange,
          careerProgression: job.careerProgression,
          isFullTimePosition: true,
        };
        navigation.navigate('SubmitForJobs', navigationParams);
        
      } catch (error) {
        console.error('❌ FULL-TIME JOBS - Error in handleJobApply (navigation):', error);
      } finally {
        setApplyingJobId(null);
      }
    }
  };
  
  // Get random color for company logo placeholder
  const getRandomColor = (str) => {
    const colors = ['#6366F1', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#3B82F6', '#EF4444'];
    const index = (str || '').length % colors.length;
    return colors[index];
  };

  // --- RENDER FUNCTIONS ---
  
  // Render header
  const renderHeader = () => (
    <View style={styles.header}>
      <TouchableOpacity
        style={styles.backButton}
        onPress={() => navigation.goBack()}
      >
        <Ionicons name="arrow-back" size={24} color="#ffffff" />
      </TouchableOpacity>
      
      <View style={styles.headerTitleContainer}>
        <Text style={styles.headerTitle}>Full-Time Jobs</Text>
        <Text style={styles.headerSubtitle}>{filteredJobs.length} career opportunities</Text>
      </View>
      
      <TouchableOpacity
        style={styles.headerActionButton}
        onPress={() => setShowFilters(true)}
      >
        <Ionicons name="options" size={20} color="#ffffff" />
      </TouchableOpacity>
    </View>
  );

  // Render search bar
  const renderSearchBar = () => (
    <View style={styles.searchContainer}>
      <View style={styles.searchInputContainer}>
        <Ionicons name="search" size={20} color="#64748B" />
        <TextInput
          style={styles.searchInput}
          placeholder="Search full-time jobs, skills, or companies..."
          value={searchQuery}
          onChangeText={handleSearch}
          placeholderTextColor="#94a3b8"
        />
        {searchQuery.length > 0 && (
          <TouchableOpacity onPress={() => handleSearch('')}>
            <Ionicons name="close-circle" size={20} color="#64748B" />
          </TouchableOpacity>
        )}
      </View>
    </View>
  );

  // Render career benefits
  const renderCareerBenefits = () => (
    <View style={styles.benefitsContainer}>
      <Text style={styles.benefitsTitle}>Full-Time Career Benefits</Text>
      <ScrollView 
        horizontal 
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.benefitsScrollContainer}
      >
        {[
          { icon: 'trending-up', title: 'Career Growth', color: '#0e4e96' },
          { icon: 'shield-checkmark', title: 'Job Security', color: '#10b981' },
          { icon: 'medical', title: 'Full Benefits', color: '#f59e0b' },
          { icon: 'school', title: 'Learning Budget', color: '#8b5cf6' },
        ].map((benefit, index) => (
          <View key={index} style={[styles.benefitCard, { borderColor: benefit.color }]}>
            <View style={[styles.benefitIcon, { backgroundColor: benefit.color }]}>
              <Ionicons name={benefit.icon} size={16} color="#ffffff" />
            </View>
            <Text style={styles.benefitTitle}>{benefit.title}</Text>
          </View>
        ))}
      </ScrollView>
    </View>
  );
  
  // ✅ NEW: Render enhanced statistics card (now with local and api counts)
  const renderStatistics = () => {
    // Define colors and names for ALL sources
    const sourceDisplayConfig = {
      jsearch: { color: '#F59E0B', name: 'JSearch' },
      googleJobs: { color: '#3B82F6', name: 'Google' },
      adzuna: { color: '#8B5CF6', name: 'Adzuna' },
      default: { color: '#6B7280', name: 'Other' },
    };

    return (
      <Animated.View
        style={[
          styles.statisticsCard,
          {
            opacity: fadeAnim,
            transform: [{ translateY: slideAnim }],
          },
        ]}
      >
        <LinearGradient
          colors={['rgba(99, 102, 241, 0.1)', 'rgba(139, 92, 246, 0.1)']}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={styles.statisticsGradient}
        >
          <View style={styles.statisticsRow}>
            <View style={styles.statItem}>
              <Text style={styles.statNumber}>{filteredJobs.length}</Text>
              <Text style={styles.statLabel}>Total Jobs</Text>
            </View>
            
            <View style={styles.statDivider} />
            
            <View style={styles.statItem}>
              <Text style={[styles.statNumber, { color: '#10B981' }]}>{localJobCount}</Text>
              <Text style={styles.statLabel}>Local</Text>
            </View>
            
            <View style={styles.statDivider} />
            
            <View style={styles.statItem}>
              <Text style={[styles.statNumber, { color: '#3B82F6' }]}>{apiJobCount}</Text>
              <Text style={styles.statLabel}>Live API</Text>
            </View>
          </View>

          {/* API Sources */}
          {Object.keys(apiSources).length > 0 && (
            <View style={styles.apiSourcesContainer}>
              {Object.entries(apiSources).map(([sourceKey, data]) => {
                if (!data.enabled) return null;
                
                const config = sourceDisplayConfig[sourceKey] || sourceDisplayConfig.default;

                return (
                  <View key={sourceKey} style={styles.apiSourceBadge}>
                    <View style={[styles.apiSourceDot, { backgroundColor: config.color }]} />
                    <Text style={styles.apiSourceText}>
                      {config.name}: {data.count}
                    </Text>
                  </View>
                );
              })}
            </View>
          )}
        </LinearGradient>
      </Animated.View>
    );
  };

  // Render tabs
  const renderTabs = () => (
    <View style={styles.tabsContainer}>
      <ScrollView 
        horizontal 
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.tabsScrollContainer}
      >
        {fullTimeTabs.map((tab) => {
          let jobCount = 0;
          switch(tab.id) {
            case 'all':
              jobCount = filteredJobs.length; 
              break;
            case 'recommended':
              jobCount = filteredJobs.filter(job => job.matchScore >= 85).length;
              break;
            case 'senior':
              jobCount = filteredJobs.filter(job => (job.experienceLevel || '').includes('Senior')).length;
              break;
            case 'saved':
              jobCount = savedJobs.filter(savedJob => filteredJobs.some(j => j.id === savedJob.id)).length;
              break;
            case 'applied':
              jobCount = jobApplications.filter(app => filteredJobs.some(j => j.id === app.jobId)).length;
              break;
            default:
              jobCount = 0;
          }

          return (
            <TouchableOpacity
              key={tab.id}
              style={[
                styles.tab,
                selectedTab === tab.id && styles.activeTab,
              ]}
              onPress={() => handleTabPress(tab)}
            >
              <Ionicons 
                name={tab.icon} 
                size={16} 
                color={selectedTab === tab.id ? "#ffffff" : "#64748B"} 
              />
              <Text style={[
                styles.tabText,
                selectedTab === tab.id && styles.activeTabText,
              ]}>
                {tab.title}
              </Text>
              {jobCount > 0 && (
                <View style={[
                  styles.tabBadge,
                  selectedTab === tab.id && styles.activeTabBadge,
                ]}>
                  <Text style={[
                    styles.tabBadgeText,
                    selectedTab === tab.id && styles.activeTabBadgeText,
                  ]}>
                    {jobCount}
                  </Text>
                </View>
              )}
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    </View>
  );

  // Render full-time job card
  const renderFullTimeJobCard = ({ item: job }) => {
    const isSaved = isJobSaved(job.id);
    const isApplied = isJobApplied(job.id);
    const isApplying = applyingJobId === job.id;
    
    // Data source badge
    const sourceBadgeConfig = {
      'JSearch': { bg: '#FFF3E0', text: '#F57C00', icon: 'search', name: 'JSearch' },
      'Google Jobs': { bg: '#E3F2FD', text: '#1976D2', icon: 'google', name: 'Google' },
      'Adzuna': { bg: '#EDE9FE', text: '#7C3AED', icon: 'briefcase', name: 'Adzuna' },
      'Local': { bg: '#F3E5F5', text: '#7B1FA2', icon: 'phone-portrait', name: 'Local' },
      'default': { bg: '#F5F5F5', text: '#757575', icon: 'document', name: 'Other' }
    };
    
    const sourceConfig = sourceBadgeConfig[job.dataSource] || sourceBadgeConfig.default;

    return (
      <Animated.View 
        style={[
          styles.jobCard,
          {
            opacity: fadeAnim,
            transform: [{ translateY: slideAnim }],
          },
        ]}
      >
        {/* Job badges */}
        <View style={styles.jobBadges}>
          <View style={[styles.badge, styles.fullTimeBadge]}>
            <Ionicons name="briefcase" size={12} color="#ffffff" />
            <Text style={styles.badgeText}>Full-Time</Text>
          </View>
          {job.featured && (
            <View style={[styles.badge, styles.featuredBadge]}>
              <Ionicons name="star" size={12} color="#ffffff" />
              <Text style={styles.badgeText}>Featured</Text>
            </View>
          )}
          {job.urgent && (
            <View style={[styles.badge, styles.urgentBadge]}>
              <Ionicons name="flash" size={12} color="#ffffff" />
              <Text style={styles.badgeText}>Urgent</Text>
            </View>
          )}
          {(job.remote || job.isRemote) && (
            <View style={[styles.badge, styles.remoteBadge]}>
              <Ionicons name="home" size={12} color="#ffffff" />
              <Text style={styles.badgeText}>Remote</Text>
            </View>
          )}
          {(job.experienceLevel || '').includes('Senior') && (
            <View style={[styles.badge, styles.seniorBadge]}>
              <Ionicons name="trending-up" size={12} color="#ffffff" />
              <Text style={styles.badgeText}>Senior</Text>
            </View>
          )}
          {/* ✅ Data Source Badge */}
          <View style={[styles.badge, { backgroundColor: sourceConfig.bg }]}>
            <Ionicons name={sourceConfig.icon} size={12} color={sourceConfig.text} />
            <Text style={[styles.badgeText, { color: sourceConfig.text }]}>
              {sourceConfig.name}
            </Text>
          </View>
        </View>

        {/* Company info */}
        <View style={styles.jobHeader}>
          <View style={styles.companyLogoContainer}>
            {job.companyLogo ? (
              <Image 
                source={{ uri: (job.companyLogo && typeof job.companyLogo=="string" && job.companyLogo.startsWith("http")) ? job.companyLogo : undefined }} 
                style={styles.companyLogo}
                onError={() => console.warn('Failed to load company logo for:', job.company)}
              />
            ) : (
              <View style={[styles.companyLogoPlaceholder, { backgroundColor: getRandomColor(job.company) }]}>
                <Text style={styles.companyLogoText}>
                  {job.company.charAt(0)}
                </Text>
              </View>
            )}
          </View>

          <View style={styles.jobInfo}>
            <Text style={styles.jobTitle} numberOfLines={2}>{job.title}</Text>
            <Text style={styles.companyName}>{job.company}</Text>
            
            <View style={styles.jobMeta}>
              <View style={styles.metaItem}>
                <Ionicons name="location" size={12} color="#64748B" />
                <Text style={styles.metaText}>{job.location}</Text>
              </View>
              <View style={styles.metaItem}>
                <Ionicons name="cash" size={12} color="#64748B" />
                <Text style={styles.metaText}>{formatSalary(job.salaryRange) || job.salary}</Text>
              </View>
            </View>
          </View>

          <TouchableOpacity
            style={styles.saveButton}
            onPress={() => handleSaveJob(job)}
          >
            <Ionicons 
              name={isSaved ? "bookmark" : "bookmark-outline"} 
              size={20} 
              color={isSaved ? "#f59e0b" : "#64748B"} 
            />
          </TouchableOpacity>
        </View>

        {/* Job description */}
        <Text style={styles.jobDescription} numberOfLines={2}>
          {job.description}
        </Text>

        {/* Full-time specific info */}
        <View style={styles.fullTimeInfoContainer}>
          <View style={styles.fullTimeInfoItem}>
            <Ionicons name="briefcase-outline" size={14} color="#0e4e96" />
            <Text style={styles.fullTimeInfoText}>{job.experienceLevel}</Text>
          </View>
          <View style={styles.fullTimeInfoItem}>
            <Ionicons name="business-outline" size={14} color="#0e4e96" />
            <Text style={styles.fullTimeInfoText}>{job.industry}</Text>
          </View>
          {job.companyInfo?.rating && (
            <View style={styles.fullTimeInfoItem}>
              <Ionicons name="star-outline" size={14} color="#0e4e96" />
              <Text style={styles.fullTimeInfoText}>{job.companyInfo.rating} rating</Text>
            </View>
          )}
        </View>

        {/* ✅ FIX: Conditionally render career progression */}
        {job.careerProgression && (
          <View style={styles.careerProgressionContainer}>
            <Text style={styles.careerProgressionTitle}>Career Growth</Text>
            <Text style={styles.careerProgressionText}>
              Next role: {job.careerProgression.nextRole} in {job.careerProgression.timeframe}
            </Text>
          </View>
        )}

        {/* Job requirements (now pulls from job.skills) */}
        {job.skills && job.skills.length > 0 && (
          <View style={styles.requirementsContainer}>
            <ScrollView 
              horizontal 
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={styles.requirementsScrollContainer}
            >
              {job.skills.slice(0, 4).map((skill, index) => (
                <View key={index} style={styles.requirementTag}>
                  <Text style={styles.requirementText}>{skill}</Text>
                </View>
              ))}
            </ScrollView>
          </View>
        )}

        {/* Match score and actions */}
        <View style={styles.jobFooter}>
          <View style={styles.matchContainer}>
            <View style={styles.matchScore}>
              <Text style={styles.matchText}>{job.matchScore}% match</Text>
            </View>
            <Text style={styles.postedTime}>{job.posted}</Text>
          </View>

          <View style={styles.actionButtons}>
            <TouchableOpacity
              style={styles.detailsButton}
              onPress={() => {
                try {
                  navigation.navigate('JobDetails', { 
                    jobId: job.id,
                    id: job.id,
                    job: job,
                    source: 'FullTimeJobsScreen'
                  });
                } catch (error) {
                  console.error('❌ FULL-TIME JOBS - Navigation to JobDetails failed:', error);
                  Alert.alert('Error', 'Unable to view job details. Please try again.');
                }
              }}
            >
              <Ionicons name="information-circle-outline" size={16} color="#0e4e96" />
              <Text style={styles.detailsButtonText}>Details</Text>
            </TouchableOpacity>

            {/* Apply Now button with proper navigation */}
            <TouchableOpacity
              style={[
                styles.applyButton,
                isApplied && styles.appliedButton,
                isApplying && styles.applyingButton,
              ]}
              onPress={() => handleJobApply(job)}
              disabled={isApplied || isApplying}
            >
              {isApplying ? (
                <>
                  <ActivityIndicator size={20} color="#ffffff" />
                  <Text style={styles.applyButtonText}>Applying...</Text>
                </>
              ) : (
                <>
                  {isApplied ? (
                    <Ionicons name="checkmark-circle" size={16} color="#ffffff" />
                  ) : (
                    <Ionicons name="paper-plane" size={16} color="#ffffff" />
                  )}
                  <Text style={[styles.applyButtonText, isApplied && styles.appliedButtonText]}>
                    {isApplied ? 'Applied' : 'Apply Now'}
                  </Text>
                </>
              )}
            </TouchableOpacity>
          </View>
        </View>
      </Animated.View>
    );
  };

  // Render empty state
  const renderEmptyState = () => (
    <View style={styles.emptyContainer}>
      <Ionicons name="briefcase-outline" size={64} color="#94a3b8" />
      <Text style={styles.emptyTitle}>No Full-Time Jobs Found</Text>
      <Text style={styles.emptyMessage}>
        Try adjusting your search criteria or check back later for new career opportunities.
      </Text>
      <TouchableOpacity
        style={styles.refreshButton}
        onPress={onRefresh} // Changed to call onRefresh
      >
        <Ionicons name="refresh" size={16} color="#0e4e96" />
        <Text style={styles.refreshButtonText}>Refresh Jobs</Text>
      </TouchableOpacity>
    </View>
  );

  // Render filter modal
  const renderFilterModal = () => (
    <Modal
      visible={showFilters}
      animationType="slide"
      presentationStyle="pageSheet"
      onRequestClose={() => setShowFilters(false)}
    >
      <SafeAreaView style={styles.modalContainer}>
        <View style={styles.modalHeader}>
          <Text style={styles.modalTitle}>Full-Time Job Filters</Text>
          <TouchableOpacity
            style={styles.modalCloseButton}
            onPress={() => setShowFilters(false)}
          >
            <Ionicons name="close" size={24} color="#64748B" />
          </TouchableOpacity>
        </View>

        <ScrollView style={styles.modalContent}>
          {/* Experience Level Filter */}
          <View style={styles.filterSection}>
            <Text style={styles.filterTitle}>Experience Level</Text>
            <View style={styles.filterOptions}>
              {['all', 'entry', 'mid', 'senior'].map((level) => (
                <TouchableOpacity
                  key={level}
                  style={[
                    styles.filterOption,
                    selectedFilters.experienceLevel === level && styles.selectedFilterOption,
                  ]}
                  onPress={() => setSelectedFilters(prev => ({ ...prev, experienceLevel: level }))}
                >
                  <Text style={[
                    styles.filterOptionText,
                    selectedFilters.experienceLevel === level && styles.selectedFilterOptionText,
                  ]}>
                    {level === 'all' ? 'All Levels' : level.charAt(0).toUpperCase() + level.slice(1)}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>
          
          {/* ✅ NEW: Engineering Discipline Filter */}
          <View style={styles.filterSection}>
            <Text style={styles.filterTitle}>Engineering Discipline</Text>
            <View style={styles.filterOptions}>
              {['all', 'civil', 'mechanical', 'electrical', 'software', 'architecture'].map((discipline) => (
                <TouchableOpacity
                  key={discipline}
                  style={[
                    styles.filterOption,
                    selectedFilters.discipline === discipline && styles.selectedFilterOption,
                  ]}
                  onPress={() => setSelectedFilters(prev => ({ ...prev, discipline: discipline }))}
                >
                  <Text style={[
                    styles.filterOptionText,
                    selectedFilters.discipline === discipline && styles.selectedFilterOptionText,
                  ]}>
                    {discipline === 'all' ? 'All Disciplines' : discipline.charAt(0).toUpperCase() + discipline.slice(1)}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>

          {/* Salary Range Filter */}
          <View style={styles.filterSection}>
            <Text style={styles.filterTitle}>Salary Range</Text>
            <View style={styles.filterOptions}>
              {['all', '40-60k', '60-80k', '80k+'].map((range) => (
                <TouchableOpacity
                  key={range}
                  style={[
                    styles.filterOption,
                    selectedFilters.salaryRange === range && styles.selectedFilterOption,
                  ]}
                  onPress={() => setSelectedFilters(prev => ({ ...prev, salaryRange: range }))}
                >
                  <Text style={[
                    styles.filterOptionText,
                    selectedFilters.salaryRange === range && styles.selectedFilterOptionText,
                  ]}>
                    {range === 'all' ? 'All Salaries' : `£${range}`}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>

          {/* Job Area Filter */}
          <View style={styles.filterSection}>
            <Text style={styles.filterTitle}>Job Area</Text>
            <View style={styles.filterOptions}>
              {['all', 'technology', 'design', 'marketing', 'data science'].map((industry) => (
                <TouchableOpacity
                  key={industry}
                  style={[
                    styles.filterOption,
                    selectedFilters.jobArea === industry && styles.selectedFilterOption,
                  ]}
                  onPress={() => setSelectedFilters(prev => ({ ...prev, jobArea: industry }))}
                >
                  <Text style={[
                    styles.filterOptionText,
                    selectedFilters.jobArea === industry && styles.selectedFilterOptionText,
                  ]}>
                    {industry === 'all' ? 'All Areas' : industry.charAt(0).toUpperCase() + industry.slice(1)}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>

          {/* Remote Work Filter */}
          <View style={styles.filterSection}>
            <Text style={styles.filterTitle}>Work Type</Text>
            <TouchableOpacity
              style={[
                styles.toggleOption,
                selectedFilters.remote && styles.selectedToggleOption,
              ]}
              onPress={() => setSelectedFilters(prev => ({ ...prev, remote: !prev.remote }))}
            >
              <Ionicons 
                name={selectedFilters.remote ? "checkbox" : "square-outline"} 
                size={20} 
                color={selectedFilters.remote ? "#0e4e96" : "#64748B"} 
              />
              <Text style={styles.toggleOptionText}>Remote Work Only</Text>
            </TouchableOpacity>
          </View>

          {/* Apply Filters Button */}
          <TouchableOpacity
            style={styles.applyFiltersButton}
            onPress={() => {
              // Re-run the main filter function with the new filters
              filterJobs(searchQuery, selectedTab, allFullTimeJobs); 
              setShowFilters(false);
            }}
          >
            <Text style={styles.applyFiltersButtonText}>Apply Filters</Text>
          </TouchableOpacity>
        </ScrollView>
      </SafeAreaView>
    </Modal>
  );

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {renderHeader()}

      {/* ✅ ADDED Loading Indicator */}
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading Full-Time Engineering Jobs...</Text>
        </View>
      ) : (
        <ScrollView
          style={styles.content}
          showsVerticalScrollIndicator={false}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor="#0e4e96" />
          }
        >
          {renderSearchBar()}
          {renderStatistics()} {/* ✅ Statistics card added */}
          {renderCareerBenefits()}
          {renderTabs()}

          <View style={styles.jobsContainer}>
            <Text style={styles.jobsTitle}>
              {fullTimeTabs.find(tab => tab.id === selectedTab)?.title || 'Full-Time Jobs'} ({filteredJobs.length})
            </Text>
            
            {filteredJobs.length > 0 ? (
              <FlatList
                data={filteredJobs}
                renderItem={renderFullTimeJobCard}
                keyExtractor={(item) => item.id}
                scrollEnabled={false}
                showsVerticalScrollIndicator={false}
              />
            ) : (
              renderEmptyState()
            )}
          </View>
        </ScrollView>
      )}

      {renderFilterModal()}
    </SafeAreaView>
  );
}

// --- STYLES ---
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0e4e96',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
  },
  loadingText: {
    marginTop: 10,
    fontSize: 16,
    color: '#64748B',
    fontWeight: '500',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#0e4e96',
  },
  backButton: {
    padding: 8,
    borderRadius: 20,
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  headerTitleContainer: {
    flex: 1,
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#ffffff',
    marginBottom: 2,
  },
  headerSubtitle: {
    fontSize: 12,
    color: 'rgba(255,255,255,0.8)',
    fontWeight: '500',
  },
  headerActionButton: {
    padding: 8,
    borderRadius: 20,
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  content: {
    flex: 1,
    backgroundColor: '#f8fafc',
  },
  searchContainer: {
    backgroundColor: '#ffffff',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  searchInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },
  searchInput: {
    flex: 1,
    fontSize: 16,
    color: '#1e293b',
    marginLeft: 12,
  },
  // ✅ Styles for Statistics Card
  statisticsCard: {
    marginHorizontal: 16,
    marginTop: 16, // Changed from -30 to sit below search
    marginBottom: 0,
    borderRadius: 16,
    overflow: 'hidden',
    elevation: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
  },
  statisticsGradient: {
    padding: 20,
  },
  statisticsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  statItem: {
    alignItems: 'center',
  },
  statNumber: {
    fontSize: 28,
    fontWeight: '700',
    color: '#6366F1', // Default color
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 14,
    color: '#6B7280',
    fontWeight: '500',
  },
  statDivider: {
    width: 1,
    height: 40,
    backgroundColor: '#E5E7EB',
  },
  apiSourcesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16,
    gap: 8,
    justifyContent: 'center',
  },
  apiSourceBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 12,
  },
  apiSourceDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 6,
  },
  apiSourceText: {
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '600',
  },
  benefitsContainer: {
    backgroundColor: '#ffffff',
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    marginTop: 16, // Added margin
  },
  benefitsTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: 16,
    paddingHorizontal: 20,
  },
  benefitsScrollContainer: {
    paddingHorizontal: 20,
  },
  benefitCard: {
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 12,
    marginRight: 12,
    borderWidth: 2,
    minWidth: 80,
  },
  benefitIcon: {
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  benefitTitle: {
    fontSize: 11,
    color: '#1e293b',
    fontWeight: '600',
    textAlign: 'center',
  },
  tabsContainer: {
    backgroundColor: '#ffffff',
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  tabsScrollContainer: {
    paddingHorizontal: 20,
  },
  tab: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 10,
    marginRight: 12,
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },
  activeTab: {
    backgroundColor: '#0e4e96',
    borderColor: '#0e4e96',
  },
  tabText: {
    fontSize: 14,
    color: '#64748B',
    fontWeight: '500',
    marginLeft: 6,
  },
  activeTabText: {
    color: '#ffffff',
  },
  tabBadge: {
    backgroundColor: '#e2e8f0',
    borderRadius: 10,
    paddingHorizontal: 6,
    paddingVertical: 2,
    marginLeft: 6,
  },
  activeTabBadge: {
    backgroundColor: 'rgba(255,255,255,0.3)',
  },
  tabBadgeText: {
    fontSize: 10,
    color: '#64748B',
    fontWeight: '600',
  },
  activeTabBadgeText: {
    color: '#ffffff',
  },
  jobsContainer: {
    backgroundColor: '#ffffff',
    marginTop: 8,
    paddingHorizontal: 20,
    paddingVertical: 20,
  },
  jobsTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: 16,
  },
  jobCard: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 20,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  jobBadges: {
    flexDirection: 'row',
    flexWrap: 'wrap', // Added wrap
    marginBottom: 12,
  },
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    marginRight: 8,
    marginBottom: 4, // Added margin bottom
  },
  fullTimeBadge: {
    backgroundColor: '#0e4e96',
  },
  featuredBadge: {
    backgroundColor: '#f59e0b',
  },
  urgentBadge: {
    backgroundColor: '#ef4444',
  },
  remoteBadge: {
    backgroundColor: '#10b981',
  },
  seniorBadge: {
    backgroundColor: '#8b5cf6',
  },
  badgeText: {
    fontSize: 10,
    color: '#ffffff',
    fontWeight: '600',
    marginLeft: 4,
  },
  jobHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  companyLogoContainer: {
    marginRight: 12,
  },
  companyLogo: {
    width: 48,
    height: 48,
    borderRadius: 12,
    backgroundColor: '#f1f5f9',
  },
  companyLogoPlaceholder: {
    width: 48,
    height: 48,
    borderRadius: 12,
    backgroundColor: '#0e4e96',
    justifyContent: 'center',
    alignItems: 'center',
  },
  companyLogoText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  jobInfo: {
    flex: 1,
  },
  jobTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: 4,
    lineHeight: 22,
  },
  companyName: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0e4e96',
    marginBottom: 8,
  },
  jobMeta: {
    flexDirection: 'row',
  },
  metaItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
  },
  metaText: {
    fontSize: 12,
    color: '#64748B',
    marginLeft: 4,
    fontWeight: '500',
  },
  saveButton: {
    padding: 8,
  },
  jobDescription: {
    fontSize: 14,
    color: '#64748B',
    lineHeight: 20,
    marginBottom: 12,
  },
  fullTimeInfoContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap', // Allow wrap
    marginBottom: 12,
  },
  fullTimeInfoItem: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#eff6ff',
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginRight: 8,
    marginBottom: 4, // Added margin
    borderWidth: 1,
    borderColor: '#bfdbfe',
  },
  fullTimeInfoText: {
    fontSize: 11,
    color: '#1e40af',
    fontWeight: '600',
    marginLeft: 4,
  },
  careerProgressionContainer: {
    backgroundColor: '#f0f9ff',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#bae6fd',
  },
  careerProgressionTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#0369a1',
    marginBottom: 4,
  },
  careerProgressionText: {
    fontSize: 11,
    color: '#0369a1',
    lineHeight: 16,
  },
  requirementsContainer: {
    marginBottom: 16,
  },
  requirementsScrollContainer: {
    paddingRight: 20,
  },
  requirementTag: {
    backgroundColor: '#eff6ff',
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginRight: 8,
    borderWidth: 1,
    borderColor: '#bfdbfe',
  },
  requirementText: {
    fontSize: 12,
    color: '#1e40af',
    fontWeight: '500',
  },
  jobFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  matchContainer: {
    flex: 1,
  },
  matchScore: {
    backgroundColor: '#dbeafe',
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
    marginBottom: 4,
  },
  matchText: {
    fontSize: 12,
    color: '#1e40af',
    fontWeight: '600',
  },
  postedTime: {
    fontSize: 11,
    color: '#94a3b8',
    fontWeight: '500',
  },
  actionButtons: {
    flexDirection: 'row',
  },
  detailsButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#eff6ff',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 12,
    marginRight: 8,
    borderWidth: 1,
    borderColor: '#bfdbfe',
  },
  detailsButtonText: {
    fontSize: 12,
    color: '#0e4e96',
    fontWeight: '600',
    marginLeft: 4,
  },
  applyButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 12,
  },
  appliedButton: {
    backgroundColor: '#10b981',
  },
  applyingButton: {
    backgroundColor: '#94a3b8',
  },
  applyButtonText: {
    fontSize: 12,
    color: '#ffffff',
    fontWeight: '600',
    marginLeft: 4,
  },
  appliedButtonText: {
    color: '#ffffff',
  },
  emptyContainer: {
    alignItems: 'center',
    paddingVertical: 40,
  },
  emptyTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1e293b',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyMessage: {
    fontSize: 14,
    color: '#64748B',
    textAlign: 'center',
    lineHeight: 20,
    marginBottom: 24,
    paddingHorizontal: 20,
  },
  refreshButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#eff6ff',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#bfdbfe',
  },
  refreshButtonText: {
    fontSize: 14,
    color: '#0e4e96',
    fontWeight: '600',
    marginLeft: 8,
  },
  modalContainer: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1e293b',
  },
  modalCloseButton: {
    padding: 8,
  },
  modalContent: {
    flex: 1,
    paddingHorizontal: 20,
  },
  filterSection: {
    marginVertical: 20,
  },
  filterTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: 12,
  },
  filterOptions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  filterOption: {
    backgroundColor: '#f8fafc',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 10,
    marginRight: 8,
    marginBottom: 8,
  },
  selectedFilterOption: {
    backgroundColor: '#0e4e96',
    borderColor: '#0e4e96',
  },
  filterOptionText: {
    fontSize: 14,
    color: '#64748B',
    fontWeight: '500',
  },
  selectedFilterOptionText: {
    color: '#ffffff',
  },
  toggleOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
  },
  selectedToggleOption: {
    backgroundColor: '#eff6ff',
  },
  toggleOptionText: {
    fontSize: 14,
    color: '#1e293b',
    fontWeight: '500',
    marginLeft: 12,
  },
  applyFiltersButton: {
    backgroundColor: '#0e4e96',
    borderRadius: 12,
    paddingVertical: 16,
    alignItems: 'center',
    marginVertical: 20,
  },
  applyFiltersButtonText: {
    fontSize: 16,
    color: '#ffffff',
    fontWeight: '600',
  },
});